const ApproachSection = () => {
  const approaches = [
    {
      title: "Precision Targeting",
      desc: "We find decision-makers who match the clients you actually want. Researched. Qualified. Ready for a real conversation."
    },
    { 
      title: "Your Voice, Not Ours",
      desc: "Every message sounds like it came from your team. Consistent with how you communicate."
    },
    {
      title: "Warm Handoffs", 
      desc: "When someone's interested, you get the intro with full context. No cold starts. Just conversations."
    },
    {
      title: "Reputation First",
      desc: "We'd rather send fewer messages than risk your name. Every touchpoint reflects the standard you've built."
    }
  ];

  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="py-20 md:py-32 px-5 md:px-12 lg:px-20 bg-black border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20">
          <div>
            <p className="text-[#6DBE2E] text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase mb-4 md:mb-6">
              The Harlem Leads Approach
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-white leading-tight tracking-tight">
              Outbound that protects what you've built.
            </h2>
          </div>

          <div className="space-y-6 md:space-y-8">
            {approaches.map((item, i) => (
              <div key={i} className="pl-4 md:pl-6 border-l border-white/10">
                <h3 className="text-white text-base md:text-lg font-medium mb-2">
                  {item.title}
                </h3>
                <p className="text-white/50 text-sm md:text-[15px] leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
